
























































































































































































import { Component, Vue } from 'vue-property-decorator';

import StepConfigureSecondContributionWealthViewModel
  from '@/vue-app/view-models/components/flagship/flagship-link-goals/steps-wealth/step-configure-second-contribution-wealth-view-model';

@Component({
  name: 'StepConfigureSecondContributionWealth',
  components: {},
})
export default class StepConfigureSecondContributionWealth extends Vue {
  view_model = Vue.observable(
    new StepConfigureSecondContributionWealthViewModel(this),
  );

  created() {
    this.view_model.initialize();
  }
}
